// extracted by mini-css-extract-plugin
module.exports = {"tabMenu":"TabMenu_tabMenu__3bRuy","tabs":"TabMenu_tabs__f-inK"};